import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';

import { playTriangleWhite } from 'images';

@withTranslation()
export default class PlayAllButton extends React.Component {
	static propTypes = {
		disabled: PropTypes.bool,
		isPlaying: PropTypes.bool,

		t: PropTypes.func.isRequired,
		onClick: PropTypes.func.isRequired
	}
	static defaultProps = {
		disabled: false
	};

	renderImage = () => (
		<div className="w-6">
			<img
				src={playTriangleWhite}
				className="w-full"
				alt="Play button" />
		</div>
	);

	render() {
		const { isPlaying, onClick, t, disabled } = this.props;

		// const content = isPlaying
		// 	? t('release-info.pause')
		// 	: t('release-info.play-all');

		const content = t('release-info.play-all');

		const btnClasses = classNames([
			'py-1',
			'w-40',
			'flex',
			'flex-row',
			'justify-center',
			'items-center',
			'rounded-full',
			'shadow-button',
			'focus:outline-none',
			'border',
			// {
			// 	'border-cerulean': isPlaying,
			// 	'border-transparent': !isPlaying,
			// 	'bg-cerulean': !isPlaying,
			// 	'pr-1': !isPlaying,
			// 	'bg-disabledGrey': disabled,
			// 	'cursor-not-allowed': disabled
			// }
			{
				'border-cerulean': false,
				'border-transparent': true,
				'bg-cerulean': true,
				'pr-1': true,
				'bg-disabledGrey': disabled,
				'cursor-not-allowed': disabled
			}
		]);

		return (
			<button
				type="button"
				disabled={disabled}
				className={btnClasses}
				onClick={onClick}>
				{
					// !isPlaying &&
					this.renderImage()
				}
				<div className="font-header text-white text-left text-sm select-none w-16 leading-none py-1 text-center">
					{ content }
				</div>
			</button>
		);
	}
}
